import { create } from 'zustand';
import type { Viewer } from 'cesium';

interface ViewerState {
  viewer: Viewer | null;
  selectedEntity: any | null;
  layerVisibility: {
    model: boolean;
    satellite: boolean;
    zones: boolean;
    navigation: boolean;
  };

  setViewer: (viewer: Viewer | null) => void;
  setSelectedEntity: (entity: any | null) => void;
  toggleLayer: (layer: keyof ViewerState['layerVisibility']) => void;
}

export const useViewerStore = create<ViewerState>((set) => ({
  viewer: null,
  selectedEntity: null,
  layerVisibility: {
    model: true,
    satellite: true,
    zones: false,
    navigation: false,
  },

  setViewer: (viewer) => set({ viewer }),

  setSelectedEntity: (entity) => set({ selectedEntity: entity }),

  toggleLayer: (layer) =>
    set((state) => ({
      layerVisibility: {
        ...state.layerVisibility,
        [layer]: !state.layerVisibility[layer],
      },
    })),
}));
